import React from 'react';
import { CountdownBar } from '../components/artTherapy/CountdownBar';
import { Hero } from '../components/artTherapy/Hero';
import { StatsGrid } from '../components/artTherapy/StatsGrid';
import { PainPoints } from '../components/artTherapy/PainPoints';
import { AudienceFit } from '../components/artTherapy/AudienceFit';
import { FourSteps } from '../components/artTherapy/FourSteps';
import { ManualPages } from '../components/artTherapy/ManualPages';
import { FlipWorksheet } from '../components/artTherapy/FlipWorksheet';
import { Bundle } from '../components/artTherapy/Bundle';
import { LibraryStats } from '../components/artTherapy/LibraryStats';
import { PricingOffer } from '../components/artTherapy/PricingOffer';
import { Reviews } from '../components/artTherapy/Reviews';
import { PrintedGallery } from '../components/artTherapy/PrintedGallery';
import { GuaranteeSeal } from '../components/artTherapy/GuaranteeSeal';
import { FaqList } from '../components/artTherapy/FaqList';
import { ClosingCta } from '../components/artTherapy/ClosingCta';
import { SiteFooter } from '../components/artTherapy/SiteFooter';
export function Landing() {
  return <div className="min-h-screen w-full overflow-x-clip bg-cream font-sans text-ink" data-id="element-267" data-mp="3tf0drt3xhx2q">
      <CountdownBar data-id="element-268" data-mp="3pf9ppx5sdv1w" />
      <main data-id="element-269" data-mp="3pguboye1c5o5">
        <Hero data-id="element-270" data-mp="3kfn1ksof6ueb" />
        <StatsGrid data-id="element-271" data-mp="3kfwvusghznpt" />
        <PainPoints data-id="element-272" data-mp="3kgophxqjbbdg" />
        <ManualPages data-id="element-273" data-mp="3kh7vqh6tobbn" />
        <FlipWorksheet data-id="element-274" data-mp="3khq42c6refzx" />
        <AudienceFit data-id="element-275" data-mp="l09z2h8gk8gd" />
        <FourSteps data-id="element-276" data-mp="l0rrt3vww4jj" />
        <Reviews data-id="element-277" data-mp="kz8d3hpwm1jv" />
        <PrintedGallery data-id="element-278" data-mp="kzqib3ujnq3x" />
        <Bundle data-id="element-279" data-mp="gywojtuf7h34" />
        <LibraryStats data-id="element-280" data-mp="gyenmjwtceov" />
        <PricingOffer data-id="element-281" data-mp="h07u9z7feywv" />
        <GuaranteeSeal data-id="element-282" data-mp="gzpzl70ewsr2" />
        <FaqList data-id="element-283" data-mp="c87zsma4ky7o" />
        <ClosingCta data-id="element-284" data-mp="c7ogp28qo3s2" />
      </main>
      <SiteFooter data-id="element-285" data-mp="c6wugi117ieg" />
    </div>;
}